export default "__VITE_ASSET__f18e2f33__"